import * as api from '../../../../api';
import PortalLoadingElement from '../../../../components/PortalLoadingElement';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import MainDetail from './MainDetail';

type WebPageProps = {
    webpageId: string;
};

const WebPage = ({ webpageId }: WebPageProps) => {
    const { data, loading } = api.useGetWebPageQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            id: webpageId,
            productionOnly: true,
        },
    });

    const webPage = data?.webpage;

    if (loading) {
        return <PortalLoadingElement />;
    }

    if (!webPage && !loading) {
        return <NotFoundResult />;
    }

    return <MainDetail webpage={webPage} />;
};

export default WebPage;
